<template>
  <div ref="container">
    <a-modal :title="title" :width="500" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:15%;height: 30%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          关闭
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form :form="form" id="accountModal">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="防伪参数">
            <a-input placeholder="请输入防伪参数" v-decorator.trim="[ 'name', validatorRules.name]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { updateSecurityConfig, selectSecurityConfig } from '@/api/api'
// import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
export default {
  name: 'AccountModal',
  mixins: [mixinDevice],
  data() {
    return {
      title: '防伪参数配置',
      visible: false,
      model: {},
      formState: {
        name: '',
      },
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        name: {
          rules: [{ required: true, message: '请输入防伪参数!' }],
        },
      },
    }
  },
  created() {},
  methods: {
    async add() {
      this.visible = true
      const res = await selectSecurityConfig()
      console.log(res, 'res')
      if (res.code == 200) {
        this.form.setFieldsValue({
          name: res.data.securityTimes,
        })
      } else {
        this.$message.error(res.data || res.msg)
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.log(values, 'this.name')
          let params = {
            uuid: '123456',
            times: values.name,
          }
          const res = await updateSecurityConfig(params)
          console.log(res, 'res')
          if (res.code == 200) {
            this.$message.success('操作成功')
            this.close()
          } else {
            // this.$message.error(res.msg)
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
</style>